<template>

    <VDialog v-model="dialogLoading" :max-width="700">
      <VCard class="pa-sm-10 pa-5">
        <VCardTitle class="text-center">Cargando información</VCardTitle>
        <VProgressLinear indeterminate color="primary"></VProgressLinear>
      </VCard>
    </VDialog>
    <div class="container text-start mt-3">
        <router-link to="/dashboard_ofertas_laborales" class="btn btn-primary">
            Ir a Ofertas Laborales
        </router-link>
    </div>

    <div class="content content-page bookmark">
        
        <div class="container">

            <div class="row">

                <projectsidebarpostulante></projectsidebarpostulante>

                <div class="col-xl-9 col-lg-9">
                    
                    
                    <div class="dashboard-sec payout-section freelancer-statements">
                        <!-- <div class="page-title portfolio-title text-center onboard-head">
                            <h3 style="margin:auto;">Detalle Oferta</h3>
                        </div> -->

                        <!-- Page Content -->
                        <div class="content" style="margin-top: -60px">
                            <div class="container">
                                <div class="row">                        
                                    <div class="col-lg-8 col-md-12">
                                        <div class="company-detail-block pt-0">
                                            <div class="company-detail">
                                                <div class="company-detail-image">
                                                    <img src="@/assets/img/agv_logo.jpg" class="img-fluid" alt="logo">
                                                </div>
                                                <div class="company-title">
                                                    <!-- <p>Soft Technologies</p> -->
                                                    <h4>{{ jobOfferDetails.work_pos }}</h4>
                                                </div>
                                            </div>
                                            <div class="company-address">
                                                <ul>
                                                    <li>
                                                        <i class="feather-map-pin"></i>{{jobOfferDetails.place}}
                                                    </li>
                                                    <li>
                                                        <i class="feather-calendar"></i>{{formatDate(jobOfferDetails.end_date)}}
                                                    </li>
                                                    <!-- <li>
                                                        <i class="feather-eye"></i>250 vistas
                                                    </li>
                                                    <li>
                                                        <i class="feather-edit-2"></i>80 Postulaciones
                                                    </li> -->
                                                </ul>
                                            </div>
                                            <div class="project-proposal-detail">
                                                <ul>
                                                    <li>
                                                        <div class="proposal-detail-img">
                                                            <img src="@/assets/img/icon/computer-line.svg" alt="icons">
                                                        </div>
                                                        <div class="proposal-detail text-capitalize">
                                                            <span class=" d-block">Tipo</span>
                                                            <p class="mb-0">{{typeOffer}}</p>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div class="proposal-detail-img">
                                                            <img src="@/assets/img/icon/user-heart-line.svg" alt="icons">
                                                        </div>
                                                        <div class="proposal-detail text-capitalize">
                                                            <span class=" d-block">Modalidad</span>
                                                          <p class="mb-0">{{typeOffer}}</p>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <ul>
                                                    <li>
                                                        <div class="proposal-detail-img">
                                                            <img src="@/assets/img/icon/translate-2.svg" alt="icons">
                                                        </div>
                                                        <div class="proposal-detail text-capitalize">
                                                            <span class=" d-block">Contrato</span>
                                                            <p class="mb-0">{{contractOffer}}</p>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="company-detail-block company-description">
                                            <h4 class="company-detail-title">Descripcion</h4>
                                            <div v-html="description"></div>
                                            
                                            <h4 class="company-detail-title">Funciones</h4>
                                            <div v-html="functions"></div>

                                            <h4 class="company-detail-title">Requisitos</h4>
                                            <div v-html="requirements"></div>
                                            
                                        </div>
                                    </div>

                                    <!-- <projectdeatailsidebar></projectdeatailsidebar> -->

                                    <!-- The Modal -->
                                    <div class="modal fade custom-modal" id="msj-success" style="border-radius: 15px;">
                                        <div class="modal-dialog modal-dialog-centered">
                                            <div class="modal-content">
                                                <!-- Modal Header -->
                                                <!-- <div class="modal-header">
                                                <h4 class="modal-title">Tu postulación fue realiza con éxito</h4>
                                                <button type="button" class="close" data-bs-dismiss="modal">
                                                <span>&times;</span>
                                                </button>
                                                </div> -->
                                                <div class="modal-header">
                                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                </div>
                                                <img src="@/assets/talento_agv/img/msj_post_exitosa.png" alt="">
                                                <a 
                                                    href="javascript:void(0);" 
                                                    class="btn btn-primary price-btn btn-block"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#msj-success"
                                                    data-bs-dismiss="modal"
                                                    @click="IrAPostulaciones"
                                                >
                                                Ir a Ofertas Laborales
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /The Modal -->

                                    <!-- The Modal -->
                                    <div ref="questionModal" class="modal fade custom-modal" id="questionsModal" role="dialog">
                                        <div class="modal-dialog modal-dialog-centered">
                                        <div class="modal-content">
                                            <!-- Modal Header -->
                                            <div class="modal-header">
                                            <h4 class="modal-title">Preguntas de la Oferta</h4>
                                            <button type="button" class="close" data-bs-dismiss="modal">
                                                <span>&times;</span>
                                            </button>
                                            </div>

                                            <!-- Modal body -->
                                            <div class="modal-body">
                                                <form @submit.prevent="completeApplication">
                                                    <div v-for="(question, index) in questions" :key="index" class="form-group">
                                                        <label>{{ index + 1 }}.- {{ question.pregunta_text }}</label>
                                                        <input v-if="question.pregunta_type === 'A'" type="text" class="form-control" v-model="question.answer" placeholder="" />
                                                        <!-- Agrega aquí otras condiciones para diferentes tipos de preguntas, si es necesario -->
                                                        <div v-if="question.pregunta_type === 'C'">
                                                            <div v-for="option in question.options" :key="option.opcion_id" class="form-check">
                                                                <input class="form-check-input" type="radio" :name="'question' + index" :value="option.opcion_text" v-model="question.answer">
                                                                <label class="form-check-label">{{ option.opcion_text }}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mt-4">
                                                    <!-- <button type="submit" class="btn btn-primary btn-block text-light">Completar Postulación</button> -->
                                                      <a href="javascript:void(0);" class="btn btn-primary price-btn btn-block" @click = "completeApplication" >
                                                        Completar Postulación
                                                      </a>
                                                    </div>
                                                    <div class="row justify-content-center mb-5">
                                                      <div v-if="showErrorMessage" class="alert alert-danger alert-dismissible fade show col-md-6" role="alert" style="position:absolute; z-index: 2; justify-content:center">
                                                        <strong>Error:</strong> {{ errorMessage }}
                                                        <button type="button" class="btn-close" @click="showErrorMessage = false" aria-label="Close"></button>
                                                      </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <!-- /The Modal -->

                                    <!-- Blog Sidebar -->
                                    <div class="col-lg-4 col-md-12 sidebar-right theiaStickySidebar project-client-view">
                                        <div class="stickysidebar">
                                            <div class="card budget-widget">
                                                <div>
                                                    <a 
                                                    href="javascript:void(0);" 
                                                    class="btn btn-primary price-btn btn-block"
                                                    @click="getQuestions"
                                                    >
                                                    Postular
                                                    </a>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <!-- /Blog Sidebar -->

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Pie de Página -->
    <footeragv></footeragv>
</template>

<script>
    import axiosIns from '@/plugins/axios.js';
    import { ref } from "vue";
    import {router} from "@/router";
    import { Modal } from 'bootstrap';
    import 'quill/dist/quill.snow.css';
    export default {
        props: {
            offerId: {
                type: Number,
                required: true
            }
        },
        components: {
          Modal,
        },
    data() {
        return {
            title: "Project Details",
            text: "Home",
            text1: "Projects",
            
            id_applicant: JSON.parse(localStorage.getItem('userData'))?.id_usuario,
            id_joboffer: null,
            jobOfferDetails: [],
            typeOffer: "",
            modeOffer: "",
            contractOffer: "",

            description: null,
            functions: null,
            requirements: null,

            questions: [],
            showErrorMessage: false,
            errorMessage: null,
            questionModal: null,
            successModal: null,
            dialogLoading: false,
        };

    },
      beforeRouteEnter(to, from, next){
        if (!localStorage.getItem('userData')) {
          router.push('/admin/login');
        }else{
          next()
        }
      },
    mounted(){
        this.id_joboffer = this.$route.query.id;
        this.getJobOffers();
        // console.log("Identificador del trabajo",this.id_joboffer);
        this.questionModal = new Modal(document.getElementById('questionsModal'));
        this.successModal = new Modal(document.getElementById('msj-success'));
    },
    methods: {

        getJobOffers(){
            const yo = this
            const config = {
                method: 'get',
                url: '/talentoagv/readJobOffer/'+yo.id_joboffer,
            }

            yo.dialogLoading = true;

            axiosIns(config)
                .then(function (response) {
                    // console.log(response.data['result'])
                    if (response.data['is_error'] === false){
                        let resultado = response.data['result']
                        for(let r of resultado){
                            if(r['id'] == yo.id_joboffer){
                                yo.jobOfferDetails = r;
                                yo.description = r['description']; 
                                yo.functions = r['functions']
                                yo.requirements = r['requirements']
                                yo.typeOffer = "TIEMPO "+r['working_day']
                                yo.modeOffer = r['work_modality']
                                yo.contractOffer = r['type_contract']
                            }
                        }
                        
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    yo.$toastr.error(response.data['message'], 'Error')
                })
                .finally(function (){
                  yo.dialogLoading = false;
                })
        },

        getQuestions(){
            const yo = this

            const data = JSON.stringify({
                id_job_offer : yo.id_joboffer
            })
            yo.dialogLoading = true;

            const config = {
                method: 'post',
                url: '/talentoagv/getQuestions/',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data,
            }

            axiosIns(config)
                .then(function (response) {
                    console.log(response.data['result'])
                    if (response.data['is_error'] === false){
                        let resultado = response.data['result']

                        yo.questions = resultado
                        if(!response.data['is_error'] && response.data['result'].length > 0){
                          yo.questionModal.show()
                        }else{
                          yo.completeApplication()
                        }

                    }
                })
                .catch(function (error) {
                    console.log(error);
                    yo.$toastr.error("Error consulte con su administrador", 'Error')
                })
                .finally(function (){
                  yo.dialogLoading = false;
                })
        },

        completeApplication() {
            const yo = this;
            this.showErrorMessage = false
            this.errorMessage = ''

            let iq = yo.questions.findIndex((question, index) => question.answer == null || question.answer == '')
            if(iq != -1){
              this.showErrorMessage = true
              this.errorMessage = 'Complete todas las preguntas'
              return false
            }
            this.dialogLoading = true
            this.questionModal.hide()

            const answers = yo.questions.map(q => ({
                question_id: q.pregunta_id,
                answer: q.answer
            }));

            const data = JSON.stringify({
                answers : answers,
                id_applicant : yo.id_applicant,
                id_job_offer : yo.id_joboffer,
            });

            const config = {
                method: 'post',
                url: '/talentoagv/completeApplication/',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data,
            };

            axiosIns(config)
                .then(function (response) {
                    if (response.data['is_error'] === false) {
                        yo.$toastr.success('Postulación completada', 'Éxito');
                        // const modal = new Modal(document.getElementById('add-category'));
                        // modal.hide();
                        // yo.$router.push("/dashboard_ofertas_laborales");
                        // yo.$router.push({ name: 'dashboard_postulante_ofertas_laborales' });
                        yo.successModal.show()
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    yo.$toastr.error(error.response.data['message'], 'Error');
                })
                .finally(function (){
                  yo.dialogLoading = false
                });
        },

        IrAPostulaciones(){
            const yo = this
            yo.$router.push("/dashboard_ofertas_laborales");
        },

        formatDate(date) {
          if (!date) return ''; // En caso de que la fecha sea nula o indefinida
          const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
          return new Date(date).toLocaleDateString('es-ES', options);
        },

    },

};
</script>